export default __webpack_public_path__ + "images/videoIcon-H1DBC/+.svg";